var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMain3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 610,
    height: 127,
    viewBox: "0 0 610 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.5 98.4001L512.1 97.2001C508.7 94.3001 508.1 89.0001 511.2 85.6001L547.6 44.0001C550.5 40.6001 555.8 40.0001 559.2 43.1001L560.6 44.3001C564 47.2001 564.6 52.5001 561.5 55.9001L525.1 97.5001C522.2 100.9 517.1 101.3 513.5 98.4001Z",
    fill: "url(#paint0_linear_411_75)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M554.7 63.7L556.2 62C556.3 61.8 556.5 61.6 556.6 61.4C555 63.2 553.3 65.1 551.7 67C552.9 65.7 553.9 64.6 554.7 63.7Z",
    fill: "url(#paint1_radial_411_75)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.7 45.3001L525.3 3.70005C522.4 0.300055 517.1 -0.299945 513.7 2.80005L512.3 4.00005C508.9 6.90005 508.3 12.2001 511.4 15.6001L542.1 50.4001L542.8 51.2001C551.9 60.3001 548.8 69.3001 546.5 73.1001C548.3 71.0001 550.1 68.9001 551.8 67.0001C553.4 65.1001 555.1 63.2001 556.7 61.4001C558.3 59.6001 559.8 57.9001 560.8 56.8001C564.3 53.4001 564.8 48.7001 561.7 45.3001Z",
    fill: "url(#paint2_linear_411_75)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M559.7 98.4001L558.3 97.2001C554.9 94.3001 554.3 89.0001 557.4 85.6001L593.8 44.0001C596.7 40.6001 602 40.0001 605.4 43.1001L606.8 44.3001C610.2 47.2001 610.8 52.5001 607.7 55.9001L571.3 97.5001C568.4 100.9 563.3 101.3 559.7 98.4001Z",
    fill: "url(#paint3_linear_411_75)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.8 63.7L602.3 62C602.4 61.8 602.6 61.6 602.7 61.4C601.1 63.2 599.4 65.1 597.8 67C599 65.7 600.1 64.6 600.8 63.7Z",
    fill: "url(#paint4_radial_411_75)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M607.8 45.3001L571.4 3.70005C568.5 0.300055 563.2 -0.299945 559.8 2.80005L558.4 4.00005C555 6.90005 554.4 12.2001 557.5 15.6001L588.2 50.4001L588.9 51.2001C598 60.3001 594.9 69.3001 592.6 73.1001C594.4 71.0001 596.2 68.9001 597.9 67.0001C599.5 65.1001 601.2 63.2001 602.8 61.4001C604.4 59.6001 605.9 57.9001 606.9 56.8001C610.4 53.4001 610.9 48.7001 607.8 45.3001Z",
    fill: "url(#paint5_linear_411_75)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.30001 98C0.900006 96.6 0.100006 94.5 0.100006 91.9V9.59998C0.100006 6.89998 0.900006 4.79998 2.60001 3.09998C4.30001 1.39998 6.40001 0.599976 9.10001 0.599976C11.8 0.599976 14.2 1.39998 15.8 3.09998C17.5 4.79998 18.3 6.89998 18.3 9.59998V85.5H57.6C63.2 85.5 66.1 88 66.1 92.9C66.1 97.8 63.2 100.3 57.6 100.3H8.60001C5.90001 100.3 3.80001 99.5 2.30001 98Z",
    fill: "#4B4C4B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3 98.6C78.6 96.9 77.8 94.7 77.8 91.9V9.5C77.8 6.8 78.6 4.7 80.3 3C82 1.3 84.1 0.5 86.8 0.5C89.5 0.5 91.9 1.3 93.5 3C95.2 4.7 96 6.8 96 9.5V91.9C96 94.6 95.2 96.9 93.5 98.6C91.8 100.3 89.6 101.1 86.8 101.1C84.2 101.1 82 100.3 80.3 98.6Z",
    fill: "#4B4C4B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200 119C200 117.3 199.4 115.7 198.4 114L193.4 106.5C190.5 101.8 187 98.6 182.7 97.2C191 93.5 197.4 87.7 201.8 79.7C206.3 71.8 208.5 62.1 208.5 51C208.5 40.7 206.6 31.7 202.8 24.1C199 16.6 193.6 10.7 186.5 6.50002C179.5 2.50002 171.1 0.400024 161.6 0.400024C151.9 0.400024 143.6 2.30002 136.5 6.50002C129.5 10.7 124 16.5 120.2 24.1C116.5 31.8 114.5 40.7 114.5 51C114.5 61.2 116.4 70.2 120.2 77.9C124 85.4 129.4 91.3 136.5 95.5C143.6 99.5 151.9 101.6 161.6 101.6C165 101.6 167.7 102.2 169.8 103.2C171.9 104.2 173.6 105.8 174.9 108L183.1 121.6C184.1 123.1 185.4 124.3 186.8 125.1C188.3 125.9 189.9 126.3 191.6 126.3C193.8 126.3 195.8 125.5 197.5 124.2C199.2 122.9 200 121.1 200 119ZM190.4 50.8C190.4 62.4 187.8 71.4 182.7 77.7C177.6 84 170.5 87.1 161.4 87.1C152.3 87.1 145.1 84 140 77.7C134.9 71.4 132.3 62.6 132.3 50.8C132.3 39 134.9 30.2 140 23.9C145.1 17.7 152.2 14.6 161.4 14.6C170.6 14.6 177.6 17.6 182.7 23.9C187.8 30.2 190.4 39 190.4 50.8Z",
    fill: "#4B4C4B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228 91.9C228 94.7001 228.8 96.9001 230.5 98.6001C232 100.3 234.3 101.1 237 101.2C239.8 101.2 242 100.4 243.7 98.7001C245.4 97.1001 246.2 94.9 246.2 92V61.8H271.3C281.9 61.8 290.1 59.2001 296 53.8C301.9 48.5 304.9 41 304.9 31.5C304.9 22 301.9 14.5 296 9.30005C290.1 3.90005 281.9 1.30005 271.3 1.30005H236.8C234.1 1.30005 232 2.10005 230.4 3.50005C228.8 5.00005 228 7.10005 228 9.80005V91.9ZM287.7 31.7C287.7 42.5 281.4 48 269 48L246.2 47.9V15.4H269C281.4 15.4 287.7 20.9 287.7 31.7Z",
    fill: "#4B4C4B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398 98.6C399.7 97 400.6 95.2 400.6 93.1C400.6 91.8 400.3 90.7 399.9 89.4L361 6.10002C360.1 4.20002 358.8 2.80002 357.1 1.80002C355.4 0.900024 353.6 0.400024 351.6 0.400024C349.6 0.400024 347.8 0.800024 346.1 1.80002C344.3 2.80002 343 4.30002 342.2 6.10002L303.4 89.4C302.9 90.6 302.6 91.9 302.6 93.1C302.6 95.3 303.4 97.2 305.2 98.6C306.9 100 309 100.8 311.1 100.8C312.7 100.8 314.1 100.4 315.4 99.6C316.7 98.8 317.7 97.6 318.5 95.9L327 77.1H376.2L384.7 95.9C385.4 97.5 386.5 98.8 387.8 99.6C389.1 100.4 390.6 100.8 392 100.8C394.3 100.8 396.3 100 398 98.6ZM370.2 63.1H333.1L351.6 21.5L370.2 63.1Z",
    fill: "#4B4C4B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.6 0.6C472.7 0.6 474.6 1.4 476.3 3.1C478 4.8 478.8 6.6 478.8 9C478.8 10.8 478.1 12.7 476.7 14.4L444.8 53.3V92.2C444.8 95.1 444 97.3 442.3 99C440.6 100.7 438.5 101.4 435.9 101.4C433.2 101.4 430.9 100.6 429.2 99C427.5 97.4 426.7 95.2 426.7 92.2V53.3L395 14.3C393.6 12.6 392.9 10.8 392.9 8.9C392.9 6.7 393.7 4.7 395.4 3C397.1 1.3 399.1 0.5 401.1 0.5C403.5 0.5 405.4 1.5 407.1 3.6L435.8 39.2L464.4 3.6C466.1 1.6 468.2 0.6 470.6 0.6Z",
    fill: "#4B4C4B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_411_75",
    x1: 524.869,
    y1: 111.384,
    x2: 575.386,
    y2: 86.8915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE81D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7072,
    stopColor: "#E89D2C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_411_75",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(534.642 68.8989) scale(24.3819 27.865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4185,
    stopColor: "#123F06",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#123F06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_411_75",
    x1: 501.864,
    y1: 36.7557,
    x2: 556.124,
    y2: 78.6128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0937643,
    stopColor: "#1FAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D7CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_411_75",
    x1: 571.069,
    y1: 111.384,
    x2: 621.586,
    y2: 86.8915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE81D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7072,
    stopColor: "#E89D2C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_411_75",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(580.783 68.8989) scale(24.3819 27.865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4185,
    stopColor: "#123F06",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#123F06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_411_75",
    x1: 547.964,
    y1: 36.7557,
    x2: 602.224,
    y2: 78.6128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0937643,
    stopColor: "#1FAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D7CFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain3);
export default __webpack_public_path__ + "static/media/main3.06a9135568093c62dc1aa850581d778a.svg";
export { ForwardRef as ReactComponent };